import React from "react";
import { AppBar, Box, Typography } from "@mui/material";

export const Footer = () => {

	return (
		<AppBar component="footer" position="static" sx={{bgcolor: "#00558C", zIndex: (theme) => theme.zIndex.drawer + 1, top: 'auto', bottom: 0, minWidth: 1600, width: "100%"}}>
			<Box sx={{margin: "0 auto", width: "100%", p: 3, display: "flex", justifyContent: "center", maxWidth: 1600}}>
				<Typography sx={{color: "#FFFFFF"}}>
					<i>You acknowledge that we have not provided you with any financial or other advice. We advise you to consult with your own financial or other advisor.</i>
				</Typography>
			</Box>
		</AppBar>
	);
};
